// bundle dùng chung 6 trang; Frame2 chỉ có ở trang điểm danh nên phải kiểm tra trước
const dayCount = document.querySelector('.pm__day-available');

if (dayCount) {
  const days = document.querySelectorAll('#Frame2 .day');

  const paintDays = () => {
    const done = parseInt(dayCount.textContent, 10) || 0;
    days.forEach((day, i) => day.classList.toggle('done', i < done));
  };

  paintDays();
  new MutationObserver(paintDays).observe(dayCount, { childList: true, characterData: true, subtree: true });

  // Frame2 chạy trong iframe của trang cha: popup canh giữa iframe (MB cao 1992px) rơi ra ngoài
  // vùng nhìn của điện thoại, nên phải canh lại theo phần iframe đang lộ trên trang cha
  const frame = window.frameElement;
  if (frame) {
    const boxes = document.querySelectorAll('.MS__popup .MS__box');

    const centerBoxes = () => {
      const rect = frame.getBoundingClientRect();
      const parentHeight = window.parent.innerHeight;
      if (rect.height <= parentHeight) {
        boxes.forEach(box => (box.style.top = ''));
        return;
      }
      // rect nằm trong hệ toạ độ đã scale của trang cha, đổi lại về px gốc của iframe
      const scale = rect.height / window.innerHeight;
      const visibleTop = Math.max(0, -rect.top);
      const visibleBottom = Math.min(rect.height, parentHeight - rect.top);
      if (visibleBottom <= visibleTop) return;
      const bandTop = visibleTop / scale;
      const bandHeight = (visibleBottom - visibleTop) / scale;
      // vùng lộ ra hẹp hơn khung thì neo mép TRÊN của khung vào đó, đừng canh giữa kẻo cụt tiêu đề
      boxes.forEach(box => {
        box.style.top = `${Math.round(bandTop + Math.max(bandHeight, box.offsetHeight) / 2)}px`;
      });
    };

    new MutationObserver(centerBoxes).observe(boxes[0].closest('.MS__outer'), {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
    window.parent.addEventListener('scroll', centerBoxes, { passive: true });
    window.parent.addEventListener('resize', centerBoxes);
  }
}

// mobile không có :hover nên mở tooltip mốc quà bằng tap; chừa .state để không chặn nút pm__btn-claim
const milestones = document.querySelectorAll('#Frame2 .dao');

milestones.forEach(dao => {
  dao.addEventListener('click', e => {
    if (e.target.closest('.state')) return;
    const wasOpen = dao.classList.contains('tooltip-open');
    milestones.forEach(d => d.classList.remove('tooltip-open'));
    dao.classList.toggle('tooltip-open', !wasOpen);
  });
});

document.addEventListener('click', e => {
  if (!e.target.closest('#Frame2 .dao')) {
    milestones.forEach(d => d.classList.remove('tooltip-open'));
  }
});
